import { render, staticRenderFns } from "./Navlink.vue?vue&type=template&id=ed9996e2&scoped=true&"
import script from "./Navlink.vue?vue&type=script&lang=js&"
export * from "./Navlink.vue?vue&type=script&lang=js&"
import style0 from "./Navlink.vue?vue&type=style&index=0&id=ed9996e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9996e2",
  null
  
)

export default component.exports